export const commonsamples_Portuguese = [
    
    {
        id:0,
        chatname:"Verificar a gramática",
        promptsandresponses:[
            {
             id:1,
             prompt:"Eu estava lá.",
             response:"Eu estava lá."
            },
        ]
    },
    {
        id:1,
        chatname:"Extrair palavras-chave",
        promptsandresponses:[
            {
             id:1,
             prompt:"Carros elétricos existem há algum tempo, mas apenas nos últimos anos é que se tornaram mais populares. Com a crescente preocupação com o meio ambiente e o aquecimento global, muitas pessoas agora estão considerando carros elétricos como uma alternativa aos carros movidos a gasolina tradicionais. Uma das principais vantagens dos carros elétricos é que eles não emitem gases prejudiciais na atmosfera, o que é uma boa notícia para o nosso planeta. Além disso, eles são muito mais silenciosos do que os carros tradicionais, tornando-os uma ótima opção para dirigir na cidade.",

             response:"Carros elétricos, meio ambiente, aquecimento global, alternativa, carros movidos a gasolina, zero emissões, gases prejudiciais, atmosfera, planeta, mais silenciosos, dirigir na cidade."
            },
        ]
    },
    {
        id:2,
        chatname:"Resumo",
        promptsandresponses:[
            {
             id:1,
             prompt:"Carros elétricos existem há algum tempo, mas apenas nos últimos anos é que se tornaram mais populares. Com a crescente preocupação com o meio ambiente e o aquecimento global, muitas pessoas agora estão considerando carros elétricos como uma alternativa aos carros movidos a gasolina tradicionais. Uma das principais vantagens dos carros elétricos é que eles não emitem gases prejudiciais na atmosfera, o que é uma boa notícia para o nosso planeta. Além disso, eles são muito mais silenciosos do que os carros tradicionais, tornando-os uma ótima opção para dirigir na cidade.",

             response:"Os carros elétricos estão ganhando popularidade devido à crescente preocupação com o meio ambiente e o aquecimento global. Eles não emitem gases prejudiciais na atmosfera e são muito mais silenciosos do que os carros tradicionais, tornando-os uma ótima opção para dirigir na cidade."
            },
        ]
    },
    {
        id:3,
        chatname:"Compacto",
        promptsandresponses:[
            {
             id:1,
             prompt:"Carros elétricos existem há algum tempo, mas apenas nos últimos anos é que se tornaram mais populares. Com a crescente preocupação com o meio ambiente e o aquecimento global, muitas pessoas agora estão considerando carros elétricos como uma alternativa aos carros movidos a gasolina tradicionais. Uma das principais vantagens dos carros elétricos é que eles não emitem gases prejudiciais na atmosfera, o que é uma boa notícia para o nosso planeta. Além disso, eles são muito mais silenciosos do que os carros tradicionais, tornando-os uma ótima opção para dirigir na cidade.",

             response:"Carros elétricos se tornaram mais populares devido às preocupações ambientais. Eles não emitem gases prejudiciais, tornando-os uma ótima opção para dirigir na cidade."
            },
        ]
    },
    {
        id:4,
        chatname:"Descrição",
        promptsandresponses:[
            {
             id:1,
             prompt:"Bolsa de couro, marrom, por menos de $29",

             response:`A bolsa de couro é um acessório elegante e funcional que é perfeito para qualquer ocasião. Feita de couro marrom de alta qualidade, essa bolsa é durável e projetada para durar. Possui um compartimento principal espaçoso que pode guardar todos os seus itens essenciais, incluindo seu celular, carteira, chaves e muito mais. A bolsa tem um design simples, porém elegante, com uma única alça de ombro que facilita o transporte. É leve e confortável, e a alça ajustável garante um ajuste perfeito para qualquer tipo de corpo.
             Melhor ainda, esta bolsa de couro está disponível por menos de $29, tornando-a uma opção acessível para qualquer pessoa que queira uma bolsa de alta qualidade sem gastar muito. Seja para fazer recados, ir ao trabalho ou sair à noite, esta bolsa de couro é o acessório perfeito para completar o seu visual.`
            },
        ]
    },
    {
        id:5,
        chatname:"E-mail",
        promptsandresponses:[
            {
             id:1,
             prompt:"Conferência de pais-professores, 12:30 quarta-feira, Remetente: Tom",

             response:`Assunto: Lembrete - Conferência de pais-professores, 12:30 quarta-feira
             \n\nPrezados pais,\n\nEspero que este e-mail os encontre bem. Apenas um lembrete rápido de que temos a conferência de pais-professores marcada para as 12:30 da tarde de quarta-feira. Essa conferência é uma ótima oportunidade para discutirmos o progresso de seu filho na escola e abordar quaisquer preocupações ou perguntas que vocês possam ter.\
             \nComo todos vocês sabem, a conferência será realizada online este ano, e vocês receberão um link para participar da conferência por e-mail. Por favor, verifiquem seus e-mails antes do início da conferência. Se tiverem alguma dificuldade técnica, não hesitem em entrar em contato comigo, e ficarei feliz em ajudá-los. Aguardo ansiosamente para encontrar todos vocês e discutir o progresso de seu filho na escola. Temos muito para conversar, então venham preparados com quaisquer perguntas ou preocupações que possam ter.
             \n\nObrigado, e nos vemos todos na quarta-feira.
             \n\nAtenciosamente,
             \n\nTom
             `
            },
        ]
    },
    {
        id:6,
        chatname:"História",
        promptsandresponses:[
            {
             id:1,
             prompt:"um pássaro, um cachorro, dia ensolarado",

             response:`Era uma vez, em um dia ensolarado, um pássaro estava pousado em um galho de árvore, cantando uma melodia. O pássaro estava desfrutando do sol quente e do ar fresco. De repente, um cachorro veio correndo em direção à árvore, latindo alto. O pássaro ficou assustado e voou para longe, mas o cachorro continuou perseguindo-o.\nO pássaro voava o mais rápido que podia, mas o cachorro era ágil e determinado. Conforme a perseguição continuava, o pássaro percebeu que o cachorro não estava tentando machucá-lo, mas sim brincar. O pássaro pousou em um galho próximo, ainda com medo, mas curioso. O cachorro tentou subir na árvore, mas estava muito alta para ele.\nO pássaro percebeu que o cachorro não era uma ameaça e decidiu brincar junto. Começou a cantar e voar ao redor, convidando o cachorro para brincar. O cachorro ficou animado e balançou o rabo felicidade. Os dois começaram a correr um atrás do outro em volta da árvore, se divertindo muito.
             Conforme o dia passava, o sol começava a se pôr, e o pássaro sabia que era hora de partir. Ele cantou um adeus para o cachorro e voou para longe. O cachorro observou-o desaparecer no horizonte, sentindo-se um pouco triste, mas também feliz pela diversão que haviam compartilhado.
             A partir desse dia, o cachorro costumava ir à árvore com a esperança de ver o pássaro novamente. Embora nunca tenham brincado juntos novamente, a lembrança daquele dia ensolarado permaneceu no coração do cachorro para sempre. Era um lembrete da alegria que vem de amizades inesperadas e da beleza da natureza em um dia ensolarado.`
            },
        ]
    },

    {
        id:7,
        chatname:"Melhorar",
        promptsandresponses:[
            {
             id:1,
             prompt:"Os carros elétricos estão ganhando popularidade devido à crescente preocupação com o meio ambiente e o aquecimento global. Eles não emitem poluentes e são muito mais silenciosos do que os carros tradicionais, tornando-os uma ótima opção para dirigir na cidade.",

             response:"Os veículos elétricos estão se tornando cada vez mais populares devido às crescentes preocupações com o meio ambiente e o aquecimento global. Esses veículos não emitem poluentes e funcionam de forma mais silenciosa do que os carros tradicionais, sendo uma escolha ideal para dirigir na cidade."
            },
        ]
    }

]
